import { API_CACHE_KEYS } from "api/cacheKeys";
import { BaseQueryOptions } from "api/types";
import { useCustomQuery } from "api/useCustomQuery";
import { JANZU_URL } from "config/config";
import { ListResponse } from "types/api";
import { ImageQuery } from "types/imageQueries";

export type GetImageQueriesParams = {
  detectorId?: string;
  pageSize?: number;

  /**
   * If provided, the request will target `/reef-api/image-queries/{type}` instead of the base list.
   */
  type?: "flagged" | "answered-v2" | "examples";
  ordering?: string;
  answer?: string;
  limit?: number;
  label?: string;
};

type UseGetImageQueriesParams = {
  params?: GetImageQueriesParams;
  options?: BaseQueryOptions<ListResponse<ImageQuery>>;
};

export function useGetImageQueries({ params, options }: UseGetImageQueriesParams = {}) {
  const basePath = params?.type ? `reef-api/image-queries/${params.type}` : "reef-api/image-queries";
  const searchParams = new URLSearchParams();

  if (params?.detectorId !== undefined) {
    // The typed list endpoints expect `predictor_id`, the base endpoint
    // uses `detecotr_id`.
    const detectorKey = params?.type ? "predictor_id" : "detector_id";
    searchParams.append(detectorKey, params.detectorId);
  }

  if (params?.pageSize !== undefined) {
    searchParams.append("page_size", params.pageSize.toString());
  }

  if (params?.ordering !== undefined) {
    searchParams.append("ordering", params.ordering);
  }

  if (params?.answer !== undefined) {
    searchParams.append("answer", params.answer);
  }

  if (params?.limit !== undefined) {
    searchParams.append("limit", String(params.limit));
  }

  if (params?.label !== undefined) {
    searchParams.append("label", params.label.toUpperCase());
  }

  const url = `${JANZU_URL}${basePath}?${searchParams.toString()}`;
  return useCustomQuery<ListResponse<ImageQuery>>(API_CACHE_KEYS.imageQueries.list(params), url, options);
}
